import img3 from "../img/portImages/amazon.png";
import img2 from "../img/portImages/resp.png";
import img1 from "../img/portImages/trvlr.png";
import img4 from "../img/portImages/editor.jpg";
import img5 from "../img/portImages/gclone.jpg";

const portfolios = [
  {
    id: 1,
    category: "Javascript, React JS,",
    image: img5,
    link1: "https://github.com/devhimanshuhc/gclone",
    link2: "https://gcloneapp.vercel.app/",
    title: "Google Clone",
    text: "It is an Google Clone created with React, Tailwind CSS, useContext",
  },
  {
    id: 2,
    category: "Javascript, React JS,",
    image: img3,
    link1: "https://github.com/devhimanshuhc/amazon-clone",
    link2: "https://cloneamazon.vercel.app/",
    title: "Amazon Clone",
    text: "It is an Amazon Clone created with React, Redux, Firebase",
  },
  {
    id: 3,
    category: "Javascript",
    image: img1,
    link1: "https://github.com/devhimanshuhc/travel-site",
    link2: "https://trvlr.vercel.app/",
    title: "TRVLR",
    text: "It's a traveling website where you can book your vacation destination",
  },
  {
    id: 4,
    category: "Javascript",
    image: img4,
    link1: "https://github.com/devhimanshuhc/image-editor",
    link2: "https://editor-image.vercel.app/",
    title: "Responsive website",
    text: "Here you can edit and save your image",
  },
  {
    id: 5,
    category: "Javascript",
    image: img2,
    link1: "https://github.com/devhimanshuhc/responsive-website",
    link2: "https://responsiveweb.vercel.app/",
    title: "Responsive website",
    text: "This is a responsive site creted HTML, CSS and Javascript",
  },
];

export default portfolios;
